import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const ContainerBox = styled.div`
  background-color: ${colors.white};
  border: .1rem solid ${colors.grey};
  border-radius: .3rem;
  margin: 0 auto 5rem;
  max-width: 105rem;
  padding: 3rem 3rem 4rem;
  text-align: center;
`;

export default ContainerBox;



// WEBPACK FOOTER //
// ./src/components/common/ContainerBox.js